import './dialog.js';

class SizeGuideLink extends HTMLElement {
  #scope;
  #observer;

  connectedCallback() {
    this.#scope = this.closest('.product-details') || this.closest('.shopify-section');
    if (!this.#scope) return;
    this.addEventListener('click', this.#open);
    this.#observer = new MutationObserver(this.#sync);
    this.#observer.observe(this.#scope, { childList: true, subtree: true });
    this.#sync();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.removeEventListener('click', this.#open);
    this.#scope = null;
  }

  #findChart = () => {
    return Array.from(this.#scope?.querySelectorAll('dialog-component[data-size-chart-product]') || [])
      .find(chart => chart.dataset.sizeChartProduct === this.dataset.productId && chart.querySelector('dialog'));
  };

  #sync = () => {
    const dialog = this.#findChart()?.querySelector('dialog');
    const button = this.querySelector('button');
    this.hidden = !dialog;
    if (dialog && button) button.setAttribute('aria-controls', dialog.id);
    else button?.removeAttribute('aria-controls');
  };

  #open = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('button')) return;
    const chart = this.#findChart();
    if (chart && typeof chart.showDialog === 'function') chart.showDialog();
    else this.#sync();
  };
}

if (!customElements.get('size-guide-link')) customElements.define('size-guide-link', SizeGuideLink);
